import React from 'react';
import { ScrollTextIcon } from 'lucide-react';
function SectionCard({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
    borderColor: '#ede9e0'
  }} data-id="element-596">
      <h2 className="text-xl md:text-2xl font-bold uppercase mb-5 pb-3 border-b" style={{
      fontFamily: 'Oswald, sans-serif',
      color: '#1e3d2f',
      borderColor: '#ede9e0'
    }} data-id="element-597">
        {title}
      </h2>
      <div className="space-y-4 text-base text-gray-800 leading-relaxed" style={{
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-598">
        {children}
      </div>
    </div>;
}
export function ByLaws() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-599">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-8" data-id="element-600">
        <section id="bylaws" data-id="element-601">
          <div className="flex items-center gap-3 mb-6 mt-4" data-id="element-602">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-603">
              <ScrollTextIcon size={20} style={{
              color: '#c8a84b'
            }} data-id="element-604" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-605">
              By-Laws
            </h2>
          </div>

          <SectionCard title="By-Law I — Membership Procedures" data-id="element-606">
            <p data-id="element-607">
              <strong data-id="element-608">Section 1.</strong> Applications for membership shall be
              available at the Club or from the Membership Manager. Completed
              applications shall be submitted with the required initiation fee
              and first year's dues.
            </p>
            <p data-id="element-609">
              <strong data-id="element-610">Section 2.</strong> Each applicant must be sponsored by a
              current member in good standing. The sponsor shall sign the
              application and attest to the applicant's character.
            </p>
            <p data-id="element-611">
              <strong data-id="element-612">Section 3.</strong> Upon acceptance, new members shall
              receive a membership card, a copy of the Club rules, and access
              credentials to the Club facilities.
            </p>
          </SectionCard>

          <div className="mt-8" data-id="element-613">
            <SectionCard title="By-Law II — Range Rules and Safety" data-id="element-614">
              <p data-id="element-615">
                <strong data-id="element-616">Section 1.</strong> All members and guests shall comply
                with the Range Rules as established by the Board of Directors
                and posted at the Club.
              </p>
              <p data-id="element-617">
                <strong data-id="element-618">Section 2.</strong> The Range Committee shall be
                responsible for maintaining safe conditions on all ranges and
                recommending rule changes to the Board of Directors.
              </p>
              <p data-id="element-619">
                <strong data-id="element-620">Section 3.</strong> Violation of range safety rules may
                result in immediate suspension of range privileges and may be
                grounds for expulsion from the Club.
              </p>
            </SectionCard>
          </div>

          <div className="mt-8" data-id="element-621">
            <SectionCard title="By-Law III — Facility Use" data-id="element-622">
              <p data-id="element-623">
                <strong data-id="element-624">Section 1.</strong> Club facilities are for the use of
                members in good standing and their guests. Members are
                responsible for the conduct of their guests at all times.
              </p>
              <p data-id="element-625">
                <strong data-id="element-626">Section 2.</strong> The Clubhouse may be rented for
                private events by members and non-members, subject to
                availability and the rules established by the Board of
                Directors.
              </p>
              <p data-id="element-627">
                <strong data-id="element-628">Section 3.</strong> All members shall participate in the
                maintenance and improvement of Club facilities as directed by
                the Board of Directors.
              </p>
            </SectionCard>
          </div>
        </section>
      </div>
    </div>;
}